import React from 'react';
import {Input} from '../../../components/ui/Input';


const EventDetailsForm = ({ 
  eventName, 
  setEventName, 
  eventDate, 
  setEventDate, 
  eventDescription, 
  setEventDescription,
  budget, // Added budget prop
  setBudget, // Added setBudget prop
  errors,
  isLoading 
}) => {
  // Get tomorrow's date for the minimum date (since backend requires future dates)
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const tomorrowString = tomorrow.toISOString().split('T')[0];

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-subtle">
      <div className="mb-6">
        <h2 className="text-lg font-semibold text-foreground mb-2">Event Details</h2>
        <p className="text-sm text-muted-foreground">
          Set up your expense sharing group with basic information
        </p>
      </div>
      <div className="space-y-4">
        <Input
          label="Event Name"
          type="text"
          placeholder="e.g., Weekend Trip, Dinner Party, Office Lunch"
          value={eventName}
          onChange={(e) => setEventName(e?.target?.value)}
          error={errors?.eventName}
          required
          disabled={isLoading}
          className="w-full"
        />

        <Input
          label="Event Date"
          type="date"
          value={eventDate}
          onChange={(e) => setEventDate(e?.target?.value)}
          error={errors?.eventDate}
          required
          disabled={isLoading}
          min={tomorrowString}
          className="w-full"
        />

        <Input
          label="Budget (Optional)"
          type="number"
          placeholder="0.00"
          value={budget}
          onChange={(e) => setBudget(e?.target?.value)}
          error={errors?.budget}
          disabled={isLoading}
          min="0"
          step="0.01"
          className="w-full"
        />

        <Input
          label="Description (Optional)"
          type="text"
          placeholder="Brief description of the event or purpose"
          value={eventDescription}
          onChange={(e) => setEventDescription(e?.target?.value)}
          error={errors?.eventDescription}
          disabled={isLoading}
          className="w-full"
        />
      </div>
    </div>
  );
};

export default EventDetailsForm;
